// Content languages only. UI locales and the default ten-language workflow remain separate.
export const EXTRA_CONTENT_LANGUAGES = [
  {
    "code": "CS",
    "name": "Czech",
    "nativeName": "Čeština",
    "flagCountryCode": "CZ",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "SK",
    "name": "Slovak",
    "nativeName": "Slovenčina",
    "flagCountryCode": "SK",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "PL",
    "name": "Polish",
    "nativeName": "Polski",
    "flagCountryCode": "PL",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "NL",
    "name": "Dutch",
    "nativeName": "Nederlands",
    "flagCountryCode": "NL",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "SV",
    "name": "Swedish",
    "nativeName": "Svenska",
    "flagCountryCode": "SE",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "DA",
    "name": "Danish",
    "nativeName": "Dansk",
    "flagCountryCode": "DK",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "FI",
    "name": "Finnish",
    "nativeName": "Suomi",
    "flagCountryCode": "FI",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "NB",
    "name": "Norwegian Bokmål",
    "nativeName": "Norsk bokmål",
    "flagCountryCode": "NO",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "HU",
    "name": "Hungarian",
    "nativeName": "Magyar",
    "flagCountryCode": "HU",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "RO",
    "name": "Romanian",
    "nativeName": "Română",
    "flagCountryCode": "RO",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "BG",
    "name": "Bulgarian",
    "nativeName": "Български",
    "flagCountryCode": "BG",
    "script": "Cyrillic",
    "isRtl": false
  },
  {
    "code": "EL",
    "name": "Greek",
    "nativeName": "Ελληνικά",
    "flagCountryCode": "GR",
    "script": "Greek",
    "isRtl": false
  },
  {
    "code": "UK",
    "name": "Ukrainian",
    "nativeName": "Українська",
    "flagCountryCode": "UA",
    "script": "Cyrillic",
    "isRtl": false
  },
  {
    "code": "TR",
    "name": "Turkish",
    "nativeName": "Türkçe",
    "flagCountryCode": "TR",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "KO",
    "name": "Korean",
    "nativeName": "한국어",
    "flagCountryCode": "KR",
    "script": "Hangul",
    "isRtl": false
  },
  {
    "code": "VI",
    "name": "Vietnamese",
    "nativeName": "Tiếng Việt",
    "flagCountryCode": "VN",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "TH",
    "name": "Thai",
    "nativeName": "ไทย",
    "flagCountryCode": "TH",
    "script": "Thai",
    "isRtl": false
  },
  {
    "code": "ID",
    "name": "Indonesian",
    "nativeName": "Bahasa Indonesia",
    "flagCountryCode": "ID",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "MS",
    "name": "Malay",
    "nativeName": "Bahasa Melayu",
    "flagCountryCode": "MY",
    "script": "Latin",
    "isRtl": false
  },
  {
    "code": "HI",
    "name": "Hindi",
    "nativeName": "हिन्दी",
    "flagCountryCode": "IN",
    "script": "Devanagari",
    "isRtl": false
  },
  {
    "code": "BN",
    "name": "Bengali",
    "nativeName": "বাংলা",
    "flagCountryCode": "BD",
    "script": "Bengali",
    "isRtl": false
  },
  {
    "code": "UR",
    "name": "Urdu",
    "nativeName": "اردو",
    "flagCountryCode": "PK",
    "script": "Arabic",
    "isRtl": true
  },
  {
    "code": "FA",
    "name": "Persian",
    "nativeName": "فارسی",
    "flagCountryCode": "IR",
    "script": "Arabic",
    "isRtl": true
  },
  {
    "code": "HE",
    "name": "Hebrew",
    "nativeName": "עברית",
    "flagCountryCode": "IL",
    "script": "Hebrew",
    "isRtl": true
  }
];
